import store from "../config/configureStore";
import { employeesView, screenNames, serviceNames } from "../utils/constants";
import { getService } from "./service";

const SHOW_SPINNER = "UI/SHOW_SPINNER";
const HIDE_SPINNER = "UI/HIDE_SPINNER";

// Drawers
const SET_CIRCULAR_LOADING = "SET_CIRCULAR_LOADING";
const SET_GLOBAL_CIRCULAR_LOADING = "SET_GLOBAL_CIRCULAR_LOADING";
const SET_EMPLOYEE_LIST_CURRENT_VIEW = "SET_EMPLOYEE_LIST_CURRENT_VIEW";

export const SET_NAVIGATION_DRAWER_MOBILE_STATE =
	"UI/SET_NAVIGATION_DRAWER_MOBILE_STATE";

export const showSpinner = () => {
	return (dispatch) => {
		dispatch({ type: SHOW_SPINNER });
	};
};

export const hideSpinner = () => {
	return (dispatch) => {
		dispatch({ type: HIDE_SPINNER });
	};
};

export const setNavigationDrawerMobileState = (state) => {
	const currentState = store.store.getState().ui.navigationDrawerMobileState;
	return async (dispatch) => {
		if (state) {
			dispatch({
				type: SET_NAVIGATION_DRAWER_MOBILE_STATE,
				payload: state,
			});
		} else {
			dispatch({
				type: SET_NAVIGATION_DRAWER_MOBILE_STATE,
				payload: !currentState,
			});
		}
	};
};
export const setCircularLoading = (flag) => {
	return async (dispatch) => {
		return dispatch({ type: SET_CIRCULAR_LOADING, payload: flag });
	};
};
export const setGlobalCircularLoading = (flag) => {
	return async (dispatch) => {
		return dispatch({ type: SET_GLOBAL_CIRCULAR_LOADING, payload: flag });
	};
};

export const setEmployeeListCurrentView = (view) => {
	return (dispatch) => {
		dispatch({ type: SET_EMPLOYEE_LIST_CURRENT_VIEW, payload: view });
	};
};

export const getScreensView = (userId) => async (dispatch) => {
	dispatch(setCircularLoading(true));
	try {
		const service = getService(serviceNames.perFilters);
		const result = await service.find({
			query: {
				screenName: { $like: "%View" },
				createdBy: userId,
			},
		});

		const employeeView = result?.find(
			(r) => r.screenName === screenNames.employeesView
		);

		if (employeeView) {
			const value = JSON.parse(employeeView?.filterValues);
			dispatch(
				setEmployeeListCurrentView(
					value?.view || employeesView.employeeGridView
				)
			);
		}
	} catch (error) {
		// dispatch({ type: FETCH_EMPLOYEE_LIST_VIEW_ERROR });
	} finally {
		dispatch(setCircularLoading(false));
	}
};

export default function reducer(
	state = {
		showSpinner: false,
		navigationDrawerMobileState: false,
		circularLoading: false,
		globalCircularLoading: false,
		employeeListCurrentView: employeesView.employeeGridView,
	},
	action
) {
	switch (action.type) {
		case SHOW_SPINNER:
			return { ...state, showSpinner: true };
		case HIDE_SPINNER:
			return { ...state, showSpinner: false };
		case SET_NAVIGATION_DRAWER_MOBILE_STATE:
			return {
				...state,
				navigationDrawerMobileState: action.payload,
			};
		case SET_CIRCULAR_LOADING:
			return { ...state, circularLoading: action.payload };
		case SET_GLOBAL_CIRCULAR_LOADING:
			return { ...state, globalCircularLoading: action.payload };
		case SET_EMPLOYEE_LIST_CURRENT_VIEW:
			return { ...state, employeeListCurrentView: action.payload };
		default:
			break;
	}
	return state;
}
